export default __webpack_public_path__ + "static/detalhe-piscina-73019f5c34a8e1c50064acad106b47ff.jpg";